import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { AvForm, AvGroup, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import { Button, FormGroup, Label, Input } from 'reactstrap';
import { post } from "../../helpers/api_helper";
import { registerUserSuccessful } from "../../store/actions";
import statecity from '../../assets/jsons/statecity.json'
import { toast } from "react-toastify";
const PageFour = (props) => {
  const [email, setEmail] = useState(null);
  const [nextStep, setNextStep] = useState(null);
  const [stateOptions, setStateOptions] = useState([]);
  const [selectedState, setSelectedState] =useState("");
  const [cityOptions, setCityOptions] = useState([]);
  useEffect(()=>{
    getEmail();
  //  console.log('all state', );
   let stateOptions = [];
   Object.keys(statecity).map((item)=>{
    stateOptions.push({label: item, value:item});
   });
   setStateOptions(stateOptions);
  }, []);

  useEffect(()=>{
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  },[])

  useEffect(()=>{
    if(selectedState){
    const city = statecity[selectedState]
    let cities = [];
    city.map((item)=>{
      cities.push({label:item, value:item});
    });
    setCityOptions(cities);
    }
  }, [selectedState]);

  const getEmail=async()=>{
    var data = await localStorage.getItem("authUser");
    if(data){
      data=JSON.parse(data);
      setEmail(data?.email);
    }
  }


  const handleValidSubmit = (event, values) => {

    const body = {
      ...values,
      step:2,
      email:props.email
    }
    // console.log('step 1 before',values);

    post('/register', body)
      .then((json => {
        // console.log('BANK DETAILS',json);
        if(json.statusCode==200){

          toast.success(json.message)
          props.onButtonClick("pagefive");
          props.registerUserSuccessful(json);


        }else{
          toast.error(json.error)
        }
      }))
  }


  return (

    <>
      <AvForm
      onValidSubmit={(e, v) => {
        handleValidSubmit(e, v)
      }}
    >
      <Row>
        <Col lg={12}>
          <h3 className="heading-title">Bank Details</h3>
        </Col>

        <Col md={4} sm={6}>
          <AvField type="text" name="bankHolderName" label="AC holder name" required />
        </Col>
        <Col md={4} sm={6}>
          <AvField type="text" name="bankName" label="Bank Name"  required/>
        </Col>
        <Col md={4} sm={6}>
          <AvField type="text" name="accountNo" label="A/C No."  required/>
        </Col>
        <Col md={4} sm={6}>
          <AvField type="text" name="ifscCode" label="IFSC Code"  required/>
        </Col>
        <Col lg={12}>
        <AvField type="checkbox" name="avFieldCheckbox" label="I agree that all the above information is accurate to the best of my knowledge." required />
        </Col>
        <FormGroup className="btn_box">
        <Button
          onClick={() => props.onButtonClick(props.expe == true ? "pagethree":"pagetwo")}
          className="common-btn back_m">Back</Button>
        <Button
            // onClick={()=>props.onButtonClick("pagefive")}
            type="submit"
            className="common-btn">Next</Button>
         {/* {
          nextStep &&  <Button
          onClick={() => onButtonClick("pagetwo")}
          className="common-btn">Next</Button>
         } */}
        </FormGroup>
      </Row>
    </AvForm>

    </>
  );
};


export default PageFour;